import { Div, Ref } from "@tblabs/truffle";


export class Panel extends Div
{
    private titleGroup = new Div().Class("panel-title-group");
    private controls = new Div().Class("panel-controls");
    public Content = new Div().Class("panel-content");

    constructor()
    {
        super();
        this.Class("panel");

        const header = new Div().Class("panel-header")
            .Append(
                this.titleGroup,
                this.controls
            );

        this.Append(
            header,
            this.Content
        );
    }

    public SetTitle(title: string, subtitle?: string)
    {
        this.titleGroup.Clear()
            .Append(
                new Div().Class("panel-title").Text(title)
            );

        if (subtitle)
        {
            this.titleGroup.Append(
                new Div().Class("panel-subtitle").Text(subtitle)
            );
        }
        return this;
    }

    public AddControl(icon: string | Ref<string>, onClick: () => void)
    {
        this.controls.Append(
            new Div()
                .Class("control-button")
                .Text(icon)
                .OnClick(onClick)
        );
        return this;
    }

    public AddContent(...content: any[])
    {
        this.Content.Append(...content);
        return this;
    }
}
